"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _createStandardI18nProvider = _interopRequireDefault(require("I18n/init/providers/createStandardI18nProvider"));

var _registerAllData = _interopRequireDefault(require("I18n/init/register/lazy/registerAllData"));

var _en = _interopRequireDefault(require("i2l?query=sporks!../lang/en.lyaml"));

var _noPortalApiClient = _interopRequireDefault(require("hub-http/clients/noPortalApiClient"));

var _reactRedux = require("react-redux");

var _configureStore = _interopRequireDefault(require("./utils/configureStore"));

var _reactRouter = require("react-router");

var _Routes = _interopRequireDefault(require("./Routes"));

var _urls = require("./utils/urls");

var _createHistory = _interopRequireDefault(require("hub-pickers-lib/utils/createHistory"));

var _reactRhumb = require("react-rhumb");

var _rhumbConfig = _interopRequireDefault(require("../rhumb-config.yaml"));

var _historyAdapterV = _interopRequireDefault(require("react-rhumb/historyAdapterV3"));

var _NotificationMiddleware = _interopRequireDefault(require("ReduxMessenger/middleware/NotificationMiddleware"));

var _Raven = _interopRequireDefault(require("Raven"));

//I18n Configuration
// import userInfo from 'hub-http/userInfo';
// import PortalIdParser from 'hubspot.PortalIdParser';
// Redux
// Configure the router
// React-rhumb
var Application = /*#__PURE__*/function () {
  function Application() {
    (0, _classCallCheck2.default)(this, Application);
  }

  (0, _createClass2.default)(Application, [{
    key: "start",
    // Kicks off the app. This is intentionally not in the constructor just in
    // case there is a reason you need to explicitly call init (and don't want it
    // auto-called by importing this module)
    value: function start() {
      var _this = this;

      if (window.jasmine) return;
      window.AppInstance = this;
      this.init().then(function (user) {
        _this.startReduxAndRaven(user);
      }).done();
    } // Performs all the initialization needed before the main app code can run/render.

  }, {
    key: "init",
    value: function init() {
      var userInfo = _noPortalApiClient.default.get('/login-verify/user-info');

      var I18nProvider = (0, _createStandardI18nProvider.default)();
      var langAvailable = Promise.all([I18nProvider.register(_en.default), (0, _registerAllData.default)(I18nProvider)]);
      return userInfo.then(function (info) {
        I18nProvider.setLocale({
          langEnabled: true,
          locale: info.user.locale
        });
        return langAvailable.then(function () {
          return info;
        });
      });
    }
  }, {
    key: "startReduxAndRaven",
    value: function startReduxAndRaven(user) {
      var middleware = [_NotificationMiddleware.default];
      this.store = (0, _configureStore.default)({
        auth: {
          user: user
        }
      }, middleware);

      _Raven.default.setUserContext({
        id: user.id,
        locale: user.locale
      });

      this.startRouter();
    }
  }, {
    key: "startRouter",
    value: function startRouter() {
      var history = (0, _createHistory.default)((0, _urls.getRootUrl)());
      (0, _reactDom.render)(_react.default.createElement(_reactRedux.Provider, {
        store: this.store
      }, _react.default.createElement(_reactRhumb.RhumbProvider, {
        history: (0, _historyAdapterV.default)(history),
        config: _rhumbConfig.default
      }, _react.default.createElement(_reactRouter.Router, {
        history: history
      }, _Routes.default))), document.getElementsByClassName('page')[0]);
    }
  }]);
  return Application;
}();

exports.default = Application;
module.exports = exports.default;